/**
 * AERO - Referral form
 *
 * Scroll reveals, the "Other" discipline toggle, the repeatable social rows
 * and client-side validation.
 *
 * El envío es nativo a propósito, igual que en contact.js: antes se mandaba
 * con fetch() y se llamaba a showSuccess() tanto desde .then() como desde
 * .catch(), sin mirar response.ok, así que una candidatura rechazada por
 * Shopify se anunciaba como enviada y se perdía. Ahora quien decide es
 * templates/page.referral.liquid con form.posted_successfully? y form.errors.
 *
 * El selector de país ya no vive aquí: es `country_option_tags` de Shopify.
 * Este archivo llegó a descargar el catálogo completo de países y ciudades de
 * countriesnow.space (varios MB, un tercero, sin timeout) solo para eso.
 */
(function () {
  'use strict';

  /* ===== DOM layer — everything in this file needs a browser ===== */
  if (typeof document === 'undefined') return;

  /* Todos los textos dinámicos de las filas de redes sociales llegan por
     data-attributes desde templates/page.referral.liquid, igual que hace
     readStrings() en assets/cart.js: así el HTML que este script inyecta al
     clonar filas no puede divergir del texto que puso el servidor. La fila 0
     (la que ya trae el servidor) usa las mismas claves de locale directamente
     en el Liquid; estas son solo la copia que necesita JS para construir las
     filas 1, 2, 3... */
  function readStrings() {
    var node = document.querySelector('.aero-referral');
    var data = (node && node.dataset) || {};
    return {
      socialOther: data.stringSocialOther || 'Other platform',
      socialOtherPlaceholder: data.stringSocialOtherPlaceholder || 'Which one?',
      socialOtherError: data.stringSocialOtherError || 'Please name the platform.',
      socialHandlePlaceholder: data.stringSocialHandlePlaceholder || 'Handle or link',
      socialHandleInputPlaceholder:
        data.stringSocialHandleInputPlaceholder || '@your_handle or link',
      socialHandleError: data.stringSocialHandleError || 'Enter your handle.',
      socialPlatformLabel: data.stringSocialPlatformLabel || 'Platform',
      socialRemove: data.stringSocialRemove || 'Remove this social network',
      optionInstagram: data.stringOptionInstagram || 'Instagram',
      optionTiktok: data.stringOptionTiktok || 'TikTok',
      optionStrava: data.stringOptionStrava || 'Strava',
      optionOther: data.stringOptionOther || 'Other',
    };
  }

  var strings = readStrings();

  /* ===== Scroll-reveal animation ===== */
  var revealEls = document.querySelectorAll('.aero-referral__reveal');
  if (revealEls.length) {
    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            io.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.15 }
    );
    revealEls.forEach(function (el) {
      io.observe(el);
    });
  }

  /* Llevar el foco al resultado que ha renderizado el servidor. */
  var landing =
    document.getElementById('referralSuccess') || document.getElementById('referralErrors');
  if (landing) {
    landing.focus();
    landing.scrollIntoView({ behavior: 'smooth', block: 'center' });
  }

  /* ===== Form logic ===== */
  var form = document.getElementById('aero-referral-form');
  if (!form) return;

  var submitBtn = form.querySelector('.aero-referral__submit');

  function inputOf(field) {
    return (
      field.querySelector('.aero-referral__input') ||
      field.querySelector('.aero-referral__select') ||
      field.querySelector('.aero-referral__textarea')
    );
  }

  /**
   * Validate a single field and toggle its error state.
   * @param {HTMLElement} field — the .aero-referral__field container
   * @returns {boolean}
   */
  function validateField(field) {
    // Un campo dentro de una fila oculta (la disciplina "Other") no cuenta.
    if (field.closest('[hidden]')) return true;

    var input = inputOf(field);
    if (!input) return true;

    var isValid = true;

    if (input.hasAttribute('required') && !input.value.trim()) {
      isValid = false;
    }

    if (input.type === 'email' && input.value.trim()) {
      var emailRe = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      if (!emailRe.test(input.value.trim())) isValid = false;
    }

    field.classList.toggle('has-error', !isValid);
    input.setAttribute('aria-invalid', isValid ? 'false' : 'true');
    return isValid;
  }

  /** Wire blur/input validation on every field inside a container. */
  function bindValidation(root) {
    root.querySelectorAll('.aero-referral__field').forEach(function (field) {
      var input = inputOf(field);
      if (!input || input.dataset.validationBound === 'true') return;

      input.dataset.validationBound = 'true';
      input.addEventListener('blur', function () {
        validateField(field);
      });
      input.addEventListener('input', function () {
        if (field.classList.contains('has-error')) validateField(field);
      });
    });
  }

  bindValidation(form);

  /* ===== Discipline "Other" toggle ===== */
  var disciplineSelect = document.getElementById('ref-discipline');
  var otherDisciplineRow = document.getElementById('ref-other-discipline-row');
  var otherDisciplineInput = document.getElementById('ref-other-discipline');

  if (disciplineSelect && otherDisciplineRow && otherDisciplineInput) {
    disciplineSelect.addEventListener('change', function () {
      var isOther = this.value === 'other';
      otherDisciplineRow.hidden = !isOther;

      if (isOther) {
        otherDisciplineInput.setAttribute('required', 'required');
        otherDisciplineInput.focus();
      } else {
        otherDisciplineInput.removeAttribute('required');
        otherDisciplineInput.value = '';
        var field = otherDisciplineInput.closest('.aero-referral__field');
        if (field) field.classList.remove('has-error');
      }
    });
  }

  /* ===== Dynamic social rows ===== */
  var socialRowsContainer = document.getElementById('ref-social-rows');
  var socialAddBtn = document.getElementById('ref-social-add');
  var socialNextIndex = 1; // siempre incrementa, para no reutilizar names

  /**
   * When a row's platform is "Other", add a free-text field beside it.
   * @param {HTMLElement} row
   */
  function attachOtherSwap(row) {
    var select = row.querySelector('.aero-referral__select');
    if (!select) return;

    select.addEventListener('change', function () {
      var platformField = row.querySelector('.aero-referral__social-platform-field');
      if (!platformField) return;

      var index = row.getAttribute('data-social-index') || '0';
      var existingCustom = row.querySelector('.aero-referral__social-custom-field');

      if (this.value === 'other') {
        row.classList.add('has-other');
        if (existingCustom) return;

        var customField = document.createElement('div');
        customField.className = 'aero-referral__field aero-referral__social-custom-field';
        customField.innerHTML =
          '<input type="text" name="contact[social_platform_custom_' +
          index +
          ']" class="aero-referral__input" placeholder="' +
          strings.socialOtherPlaceholder +
          '" aria-label="' +
          strings.socialOther +
          '" required>' +
          '<span class="aero-referral__error-msg">' +
          strings.socialOtherError +
          '</span>';

        platformField.after(customField);
        bindValidation(row);
        customField.querySelector('input').focus();
      } else {
        row.classList.remove('has-other');
        if (existingCustom) existingCustom.remove();
      }
    });
  }

  if (socialRowsContainer && socialAddBtn) {
    var firstRow = socialRowsContainer.querySelector('.aero-referral__social-row');
    if (firstRow) attachOtherSwap(firstRow);

    /**
     * Build one more username + platform row.
     * @param {number} index
     * @returns {HTMLElement}
     */
    function createSocialRow(index) {
      var row = document.createElement('div');
      row.className = 'aero-referral__social-row';
      row.setAttribute('data-social-index', index);

      row.innerHTML =
        '<div class="aero-referral__field aero-referral__social-user-field">' +
        '<input type="text" name="contact[social_user_' +
        index +
        ']" class="aero-referral__input" placeholder="' +
        strings.socialHandleInputPlaceholder +
        '" aria-label="' +
        strings.socialHandlePlaceholder +
        '" required>' +
        '<span class="aero-referral__error-msg">' +
        strings.socialHandleError +
        '</span>' +
        '</div>' +
        '<div class="aero-referral__field aero-referral__social-platform-field">' +
        '<div class="aero-referral__select-wrap">' +
        '<select name="contact[social_platform_' +
        index +
        ']" class="aero-referral__select" aria-label="' +
        strings.socialPlatformLabel +
        '" required>' +
        '<option value="" disabled selected>' +
        strings.socialPlatformLabel +
        '</option>' +
        '<option value="instagram">' +
        strings.optionInstagram +
        '</option>' +
        '<option value="tiktok">' +
        strings.optionTiktok +
        '</option>' +
        '<option value="strava">' +
        strings.optionStrava +
        '</option>' +
        '<option value="other">' +
        strings.optionOther +
        '</option>' +
        '</select>' +
        '</div>' +
        '</div>' +
        '<button type="button" class="aero-referral__social-remove" aria-label="' +
        strings.socialRemove +
        '">' +
        '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M18 6 6 18M6 6l12 12"/></svg>' +
        '</button>';

      row.querySelector('.aero-referral__social-remove').addEventListener('click', function () {
        row.style.opacity = '0';
        row.style.transform = 'translateY(-8px)';
        row.style.transition = 'opacity 0.2s ease, transform 0.2s ease';
        setTimeout(function () {
          row.remove();
          socialAddBtn.focus();
        }, 200);
      });

      attachOtherSwap(row);
      return row;
    }

    socialAddBtn.addEventListener('click', function () {
      var newRow = createSocialRow(socialNextIndex);
      socialRowsContainer.appendChild(newRow);
      socialNextIndex += 1;
      bindValidation(newRow);
      newRow.querySelector('.aero-referral__input').focus();
    });
  }

  /* ===== Submit gate =====
     Solo se cancela el envío si algo está mal; si todo está bien el navegador
     hace el POST de verdad y Shopify decide. */
  form.addEventListener('submit', function (e) {
    var firstInvalid = null;

    form.querySelectorAll('.aero-referral__field').forEach(function (field) {
      if (!validateField(field) && !firstInvalid) firstInvalid = field;
    });

    var consent = form.querySelector('#referral-consent');
    if (consent && !consent.checked && !firstInvalid) {
      e.preventDefault();
      consent.focus();
      return;
    }

    if (firstInvalid) {
      e.preventDefault();
      var input = inputOf(firstInvalid);
      if (input) input.focus();
      return;
    }

    if (submitBtn) {
      submitBtn.classList.add('is-loading');
      submitBtn.disabled = true;
    }
  });

  /* Volver atrás restaura la página desde la bfcache con el botón todavía
     deshabilitado, así que se rearma al mostrarse. */
  window.addEventListener('pageshow', function () {
    if (!submitBtn) return;
    submitBtn.classList.remove('is-loading');
    submitBtn.disabled = false;
  });
})();
